export const bylineCustomTokenTrigger = '%';
// will be used as enum
export const BylineCustomToken = {
  CurrentAuthor: `${bylineCustomTokenTrigger}currentAuthor`
};
export const bylineCustomTokens: { id: number, name: string }[]= [{ id: -1, name: BylineCustomToken.CurrentAuthor }];
